import React, { useEffect, Dispatch, SetStateAction } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import LoadingContent from "../../LoadingContent";
import { countryCodeToFlag } from "../../../utils/Admin";
import { getRandomReportMessage } from "../../../utils/General";

interface FacebookProps {
  data: any;
  facebookEmbed: string;
  setFacebookEmbed: Dispatch<SetStateAction<string>>;
  onIndividualSubmit: () => void; // Nueva prop recibida del padre
  uploading: boolean; // Nueva prop recibida del padre
}

const NewsFacebook = ({
  data,
  facebookEmbed,
  setFacebookEmbed,
  onIndividualSubmit,
  uploading,
}: FacebookProps) => {
  const MAX_CHARS = 63206;
  const charCount = facebookEmbed.length;
  const isOverLimit = charCount > MAX_CHARS;

  useEffect(() => {
    if (!data) return;
    if (data.news.grand_prix_event_id != null) {
      const flag = countryCodeToFlag(
        data.news.grand_prix_event.grand_prix.flag.code,
      );
      setFacebookEmbed(
        getRandomReportMessage(
          flag,
          data.news.grand_prix_event.name,
          data.reportLinkEn,
        ),
      );
    } else {
      setFacebookEmbed(
        [
          `🗞️${data.news.title_en.toUpperCase()}`,
          `${data.news.caption_en}`,
          "",
          `🇬🇧 English: ${data.reportLinkEn}`,
          `🇪🇸 Español: ${data.reportLinkEs}`,
          data.entriesText,
          data.youtube != null
            ? `Watch the full video here: https://www.youtube.com/watch?v=${data.youtube}`
            : ``,
        ].join("\n"),
      );
    }
  }, [data, setFacebookEmbed]);

  if (data == null) return <LoadingContent />;

  return (
    // Cambiado de <Form> a <div className="facebook-form">
    <div className="facebook-form mb-4 p-3 border rounded shadow-sm">
      <Row className="mb-3">
        <Form.Group className="form-group col-md-12">
          <h4>
            <FontAwesomeIcon
              icon={faFacebook}
              className="me-2"
              style={{ color: "#1877F2" }}
            />
            Facebook [Including News Image]
          </h4>
        </Form.Group>

        <Form.Group className="form-group" as={Col} md="12">
          <div
            style={{
              marginTop: "6px",
              fontSize: "13px",
              textAlign: "right",
              color: isOverLimit ? "red" : "#dfdfdf",
            }}
          >
            {charCount} / {MAX_CHARS}
          </div>
          <Form.Label>Post (*)</Form.Label>
          <Form.Control
            required
            as="textarea"
            name="facebook_embed"
            rows={8}
            value={facebookEmbed}
            onChange={(e) => setFacebookEmbed(e.target.value)}
            isInvalid={isOverLimit}
          />
        </Form.Group>
      </Row>

      {/* Botón para enviar solo Facebook */}
      <div className="text-center">
        {uploading ? (
          <FontAwesomeIcon icon={faSpinner} className="spinner-button" spin />
        ) : (
          <Button
            type="button" // ESENCIAL: type="button" evita enviar todo el formulario general del padre
            variant="secondary"
            onClick={onIndividualSubmit}
            disabled={isOverLimit}
          >
            Send Facebook Post Only
          </Button>
        )}
      </div>
    </div>
  );
};

export default NewsFacebook;
